import { useEffect, useRef } from 'react';
import { desenhar, montar, type Personalizacao, type Retangulo, type Visual } from '../../look/personalizacao';

interface Props {
  p: Personalizacao | null;
  visual: Visual;
  recorte: Retangulo | null;
  width: number;
  height: number;
  className?: string;
  onFalha?: () => void;
}

export function AvatarCriacao({ p, visual, recorte, width, height, className, onFalha }: Props) {
  const ref = useRef<HTMLCanvasElement>(null);
  const falhaRef = useRef(onFalha);
  falhaRef.current = onFalha;
  const sex = visual.sex;
  const skinHue = visual.skinHue;
  const hairStyle = visual.hairStyle;
  const hairHue = visual.hairHue;
  const beardStyle = visual.beardStyle;
  const beardHue = visual.beardHue;
  const rx = recorte?.[0];
  const ry = recorte?.[1];
  const rw = recorte?.[2];
  const rh = recorte?.[3];

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas || !p || !recorte) return;
    let cancelado = false;
    montar(p, { sex, skinHue, hairStyle, hairHue, beardStyle, beardHue })
      .then(m => { if (!cancelado) desenhar(canvas, m, recorte); })
      .catch(() => { if (!cancelado) falhaRef.current?.(); });
    return () => { cancelado = true; };
  }, [p, sex, skinHue, hairStyle, hairHue, beardStyle, beardHue, rx, ry, rw, rh, width, height, recorte]);

  return <canvas ref={ref} className={className} width={width} height={height} aria-hidden="true" />;
}
